<script lang="ts" setup>
import { computed } from 'vue';
import FieldChoice from '../../../properties/FieldChoice.vue';
import FieldCondition from '../../../properties/FieldCondition.vue';
import { Option } from '@/helpers/Interfaces';
import { FormBuilderContract } from '@/components/builder/form';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { NeverChoice } from '@/components/builder/form/enums/NeverChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';
import { TableType } from '..';

defineOptions({
    name: 'can-add-row',
    components: {
        'field-choice': FieldChoice,
        'field-condition': FieldCondition
    }
});

const props = defineProps({
  "blueprint": null,
  "form": null,
  "label": { default: null }
});
const blueprint = computed(() => props.blueprint);

const requiredOptions: Option<AlwaysChoice | NeverChoice | WhenChoice>[] = [
    { value: AlwaysChoice.Always, text: '[[[Zawsze]]]' },
    { value: NeverChoice.Never, text: '[[[Nigdy]]]' },
    { value: WhenChoice.When, text: '[[[Warunkowo]]]' }
];
</script>

<template>
    <div>
        <field-choice v-model="blueprint.canAddRow" :options="requiredOptions" :label="label || $t('[[[Pozwól na dodawanie wierszy]]]')" />
        <field-condition v-model="blueprint.canAddRowWhen" :label="label" :show-label="false" :form="form" :when="blueprint.canAddRow" />
    </div>
</template>
